import React from 'react';
import {View, StyleSheet,Text } from '@react-pdf/renderer';
import TableHeader from './TableHeader'
import TableRow from './TableRow'
import TableBlankSpace from './TableBlankSpace'
import TableFooterPayments from './TableFooterPayments'
import { Table } from 'react-bootstrap';

const styles = StyleSheet.create({
    tableContainer: {
        width: '97%',
        margin: '15 auto',
        paddingBottom: 20,
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
      backgroundColor: '#e2e2e2',
      display: 'flex',
      flexDirection: 'row',
    },
    headers: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        textAlign: 'center',
        flexWrap: 'wrap',
        height:24
    },
    text:{
      display: 'flex',
      fontSize:'8px',
      alignSelf:'center',
      fontWeight:'300'
    },
    tableRow: {
      display: 'flex',
      flexDirection: 'row',
    },
    cell: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      fontSize:'8px',
      textAlign: 'center',
      paddingTop: '2px',
      paddingLeft: '2px'
      
    },
    itemcode: {
        minWidth: '20%',
        maxWidth: '20%',
    },
    ean: {
        minWidth: '10%',
        maxWidth: '10%',         
    },
    qty: {
        minWidth: '20%',
        maxWidth: '20%',
    },
    unit: {
        minWidth: '40%',
        maxWidth: '40%'
    },
    description: {
        minWidth: '10%',
        maxWidth: '10%',
    },
    price: {
      minWidth: '15%',
      maxWidth: '15%',
  },
    dicount: {
        minWidth: '10%',
        maxWidth: '10%'
    },
    igv: {
        minWidth: '10%',
        maxWidth: '10%',
    },
    isc: {
        minWidth: '10%',
        maxWidth: '10%',
    },
    total: {
        minWidth: '10%',
        maxWidth: '10%',
    },
    saldov: {
        minWidth: '15%',
        maxWidth: '15%',
    },
});

const TitleModal = (docType, item ) => {
    let title = '';
    
    switch (docType) {
        case '17':
            title = 'Orden de Venta ';
            break;
        case '15':
            title = 'Entrega ';
            break;
        case '13':
            if(item.DocSubType === '--' ){
                title = 'Factura ';
            }else if(item.DocSubType === 'DN'){
                title = 'Nota de Débito ' ;
            }else if(item.isIns === 'Y'){
                title = 'Factura de reserva de clientes';
            }
            break;
        case '16':
            title = 'Devolución ';
            break;
        case '21':
            title = 'Devolución de Mercancía ';
            break;
        case '14':
            title = 'Nota de Crédito ';
            break;
        case 'payment':
            title = 'Pagos Recibidos ';
            break;
        case 'transfers':
            title = 'Traslado de Mercancía ';
            break;
        case 'transfersRequest':
            title = 'Solicitud de Traslado ';
            break;
        case 'transfersEntry':
            title = 'Entrada de Mercancía ';
            break;
        case 'transfersOutput':
            title = 'Salida de Mercancía ';
            break;
        case 'invoiceAuthorization':
            title = 'Borrador [Pendiente] ';
            break;
        case 'invoiceBorrador':
            title = 'Borrador [Autorizado] ';
            break;
        case '22':
            title = 'Orden de Compra ' ;
            break;
        case '20':
            title = 'Entrada de Mercancía ' ;
            break;
        case 'SalesHelmets':
            title = 'Entrada de Mercancía Cascos';
            break;
        case 'ExitHelmets':
            title = 'Salida de Mercancía Cascos';
            break;
        case 'PurchaseRequest':
            title = 'Solicitud de Compra ' ;
            break;
        case 'inventoryRevaluation':
            title = 'Revalorización de Inventario ' ;
            break;
        case '18':
            title = 'Factura de Proveedores ';
            break;
        case 'outgoingPayment':
            title = 'Pagos Efectuados';
            break;
        case 'invoiceReserve':
            title = 'Factura de reserva de clientes';
            break;
        case '23':
            title = 'Oferta de venta ';
            break;
        case '24':
            title = 'Pago recibido ';
            break;
        
        default:
            
    }
    return title;
};

  const ItemsTablePaymets = ({items, header, checks, cards, view}) => {
    // let blankRows = Array((items.length + 2) - items.length).fill(0)
    let balanceDueTotal= 0.00;
    let balanceDue = 0.00;
    return(
        <>
        <View style={styles.tableContainer}> 
            <View style={styles.header} fixed>
            <View style={[styles.headers,styles.itemcode]}>
                <Text style={styles.text}>DOCUMENTO</Text>
            </View>
            <View style={[styles.headers,styles.itemcode]}>
                <Text style={styles.text}>TIPO</Text>
            </View>
            <View style={[styles.headers,styles.ean]}>
                <Text style={styles.text}>FECHA</Text>
            </View>
            <View style={[styles.headers,styles.saldov]}>
                <Text style={styles.text}>TOTAL</Text>
            </View>
            <View style={[styles.headers,styles.saldov]}>
                <Text style={styles.text}>SALDO VENCIDO</Text>
            </View>
            <View style={[styles.headers,styles.saldov,]}>
                <Text style={styles.text}>PAGO TOTAL</Text>
            </View> 
            
            </View>
            {items.map( (item, index) => ( 
            <View style={styles.tableRow}>
                <View style={[styles.cell,styles.itemcode]}>
                    <Text>{item.DocNum || ''}</Text>
                </View>
                <View style={[styles.cell,styles.itemcode]}>
                    <Text>{`${TitleModal(item.ObjType, item)}` || ''}</Text>
                </View>
                <View style={[styles.cell,styles.ean]}>
                    <Text>{`${item.TaxDate.substring(0,10) || ''}`}</Text>
                </View>
                <View style={[styles.cell,styles.saldov]}>
                    <Text>{Number.parseFloat(item.DocTotal).toFixed(2) || ''}</Text>
                </View>
                <View style={[styles.cell,styles.saldov]}>
                    <Text>{item.DocCur === 'SOL' ? Number.parseFloat(item.DocTotal - item.PaidToDate).toFixed(2) : Number.parseFloat(item.DocTotalFC - item.PaidFC).toFixed(2)}</Text>
                    {balanceDue =  (item.DocCur === 'SOL' ? Number.parseFloat(item.DocTotal - item.PaidToDate).toFixed(2) : Number.parseFloat(item.DocTotalFC - item.PaidFC).toFixed(2))}
                    {balanceDueTotal = Number(balanceDue) + Number(balanceDueTotal)}
                </View>
            
                <View style={[styles.cell,styles.saldov]}>
                    <Text>{`${Number.parseFloat(item.totalPago).toFixed(2)}`}</Text>
                </View>
            </View>
            ))}
        </View>
        
        <View style={styles.tableContainer}> 
            <View style={styles.header} fixed>
            <View style={[styles.headers,styles.itemcode]}>
                <Text style={styles.text}>TIPO DE PAGO</Text>
            </View>
            <View style={[styles.headers,styles.ean]}>
                <Text style={styles.text}>FECHA</Text>
            </View>
            <View style={[styles.headers,styles.qty]}>
                <Text style={styles.text}>CUENTA A MAYOR</Text>
            </View>
            <View style={[styles.headers,styles.unit]}>
                <Text style={styles.text}>REFERENCIA / No.CHEQUE / No.VOUCHER / CUENTA</Text>
            </View>
            
            <View style={[styles.headers,styles.igv,]}>
                <Text style={styles.text}>MONTO</Text>
            </View> 
            
            </View>
            {Number.parseFloat(header.CashSum).toFixed(2) != 0.00 &&
                <View style={styles.tableRow}>
                    <View style={[styles.cell,styles.itemcode]}>
                        <Text>{"Efectivo"}</Text>
                    </View>
                    <View style={[styles.cell,styles.ean]}>
                        <Text>{header.DocDate}</Text>
                    </View>
                    <View style={[styles.cell,styles.qty]}>
                        <Text>{header.CashAcct}</Text>
                    </View>
                    <View style={[styles.cell,styles.unit]}>
                        <Text>{"--"}</Text>
                    </View>
                
                    <View style={[styles.cell,styles.igv]}>
                        <Text>{Number.parseFloat(header.CashSum).toFixed(2)}</Text>
                    </View>
                </View>
            }
            {Number.parseFloat(header.TrsfrSum).toFixed(2) != 0.00 &&
                <View style={styles.tableRow}>
                    <View style={[styles.cell,styles.itemcode]}>
                        <Text>{"Transferencia"}</Text>
                    </View>
                    <View style={[styles.cell,styles.ean]}>
                        <Text>{header.DocDate}</Text>
                    </View>
                    <View style={[styles.cell,styles.qty]}>
                        <Text>{header.TrsfrAcct}</Text>
                    </View>
                    <View style={[styles.cell,styles.unit]}>
                        <Text>{header.TrsfrRef}</Text>
                    </View>
                
                    <View style={[styles.cell,styles.igv]}>
                        <Text>{Number.parseFloat(header.TrsfrSum).toFixed(2)}</Text>
                    </View>
                </View>
            }
            {checks.map( (item, index) => ( 
            <View style={styles.tableRow}>
                <View style={[styles.cell,styles.itemcode]}>
                    <Text>{"Cheque"}</Text>
                </View>
                <View style={[styles.cell,styles.ean]}>
                    <Text>{`${item.DueDate || ''}`}</Text>
                </View>
                <View style={[styles.cell,styles.qty]}>
                    <Text>{item.CheckAct || ''}</Text>
                </View>
                <View style={[styles.cell,styles.unit]}>
                    <Text>{item.CheckNum || ''}</Text>
                </View>
            
                <View style={[styles.cell,styles.igv]}>
                    <Text>{`${Number.parseFloat(item.CheckSum).toFixed(2)}`}</Text>
                </View>
            </View>
            ))}
            {cards.map( (item, index) => ( 
            <View style={styles.tableRow}>
                <View style={[styles.cell,styles.itemcode]}>
                    <Text>{"Tarjeta"}</Text>
                </View>
                <View style={[styles.cell,styles.ean]}>
                    <Text>{`${item.FirstDue.substring(0,10) || ''}`}</Text>
                </View>
                <View style={[styles.cell,styles.qty]}>
                    <Text>{item.CreditAcct || ''}</Text>
                </View>
                <View style={[styles.cell,styles.unit]}>
                    <Text>{item.VoucherNum || ''}</Text>
                </View>
                <View style={[styles.cell,styles.igv]}>
                    <Text>{`${Number.parseFloat(item.CreditSum).toFixed(2)}`}</Text>
                </View>
            </View>
            ))}
            
            
            <TableFooterPayments header={header} items = {items} view={view} balanceDueTotal = {balanceDueTotal}/>         
        </View> 
      </>
      
    );
};
  
  export default ItemsTablePaymets